import { useAppSelector } from "../hooks/useSelector";
import AccessDenied from "../pages/AccessDenied";
import LoadingPage from "../pages/LoadingPage";

interface PermissionProps {
  is_read?: boolean;
  is_create?: boolean;
  is_update?: boolean;
  is_delete?: boolean;
}

interface Props {
  children: any;
  small?: boolean;
  requiredPermissions: PermissionProps; // Required permissions for this page
  menuSlug: string; // Slug of the menu item to match
}

export default function ProtectedPermissionPage(props: Props) {
  const { children, small, requiredPermissions, menuSlug } = props;
  const { user, menu } = useAppSelector((state) => state.global);
  if (!user) {
    return <LoadingPage />;
  }

  // Find the menu item based on the slug
  const menuItem = menu.find(
    (menu: { slug: string }) => menu.slug === menuSlug
  );

  // Check if user has the required permissions for this page
  const hasMenuPermission = menuItem
    ? Object.keys(requiredPermissions).every((key) => {
        return (
          requiredPermissions[key as keyof PermissionProps] === false ||
          menuItem[key as keyof PermissionProps]
        );
      })
    : false;

  if (!hasMenuPermission) {
    return <AccessDenied small={small} />;
  }

  return children;
}
